import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ExtraOptions, NoPreloading, PreloadAllModules, RouterStateSnapshot, Routes } from '@angular/router';
import { CatalogContentAndSearchResolver, ContentResolver, UnknownContentResolver } from 'src/core-lib/navigation/services/content.resolver';


export namespace RouteConfig {
    export let isFirst: boolean = true;
    export const pages = {
        notFoundPage: (path: string) => ({
            path,
            pathMatch: 'full',
            runGuardsAndResolvers: 'always',
            resolve: { content: (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(UnknownContentResolver).resolve(route, state) },
            loadComponent: () => import('./content-page/content-page.component').then(m => m.ContentPageComponent)
        }),
        contentPage: (path: string) => ({
            path,
            pathMatch: 'full',
            runGuardsAndResolvers: 'always',
            resolve: { content: (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(ContentResolver).resolve(route, state) },
            loadComponent: () => import('./content-page/content-page.component').then(m => m.ContentPageComponent)
        }),
        homePage: (path: string) => ({
            path,
            pathMatch: 'full',
            runGuardsAndResolvers: 'always',
            resolve: { content: (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(ContentResolver).resolve(route, state) },
            loadComponent: () => import('./content-page/home-page.component').then(m => m.HomePageComponent)
        }),
        searchPage: (path: string) => ({
            path,
            pathMatch: 'full',
            runGuardsAndResolvers: 'always',
            resolve: { content: (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(CatalogContentAndSearchResolver).resolve(route, state) },
            loadComponent: () => import('./catalog-page/catalog-page.component').then(m => m.CatalogPageComponent)
        }),
        catalogPage: (path: string) => ({
            path,
            pathMatch: 'full',
            runGuardsAndResolvers: 'always',
            resolve: { content: (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(CatalogContentAndSearchResolver).resolve(route, state) },
            loadComponent: () => import('./catalog-page/catalog-page.component').then(m => m.CatalogPageComponent)
        }),
        productPage: (path: string) => ({
            path: `${path.endsWith('product') ? path : path.split('/').slice(0, -2).join('/')}/:id/:title`,
            pathMatch: 'full',
            runGuardsAndResolvers: 'always',
            resolve: { content: (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(ContentResolver).resolve(route, state) },
            loadComponent: () => import('./product-page/product-page.component').then(m => m.ProductPageComponent)
        }),
        articleOverview: (path: string) => ({
            path,
            pathMatch: 'full',
            runGuardsAndResolvers: 'always',
            resolve: { content: (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(ContentResolver).resolve(route, state) },
            loadComponent: () => import('./article/article-overview/article-overview.component').then(m => m.ArticleOverviewComponent)
        }),
        articlePage: (path: string) => ({
            path,
            pathMatch: 'full',
            runGuardsAndResolvers: 'always',
            resolve: { content: (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(ContentResolver).resolve(route, state) },
            loadComponent: () => import('./article/article-page/article-page.component').then(m => m.ArticlePageComponent)
        }),
        basketPage: (path: string) => ({
            path,
            pathMatch: 'full',
            runGuardsAndResolvers: 'always',
            resolve: { content: (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(ContentResolver).resolve(route, state) },
            loadComponent: () => import('./checkout-page/pages/basket-page/basket-page.component').then(m => m.BasketPageComponent)
        }),
        checkoutPage: (path: string) => ({
            path,
            pathMatch: 'full',
            runGuardsAndResolvers: 'always',
            resolve: { content: (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(ContentResolver).resolve(route, state) },
            loadComponent: () => import('./checkout-page/pages/checkout-page/checkout-page.component').then(m => m.CheckoutPageComponent)
        }),
        receiptPage: (path: string) => ({
            path,
            pathMatch: 'full',
            runGuardsAndResolvers: 'always',
            resolve: { content: (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(ContentResolver).resolve(route, state) },
            loadComponent: () => import('./checkout-page/pages/invoice-page/invoice-page.component').then(m => m.InvoicePageComponent)
        }),
    }

    export const routerOptions: ExtraOptions = {
        onSameUrlNavigation: 'reload',
        scrollPositionRestoration: 'enabled',
        preloadingStrategy: PreloadAllModules,
        anchorScrolling: 'enabled',
        enableViewTransitions: true,
        initialNavigation: 'enabledBlocking'
        // useHash: true,
    };

    export function fixUrl(params) {
        if (params.startsWith('/'))
            params = params.replace('/', '');
        if (params.endsWith('/'))
            params = params.slice(0, -1);
        return params;
    }
    export function routes() {
        var lang = (document.body.parentNode as HTMLElement)?.lang;
        var _routes: { [key: string]: string } = {};
        try {
            _routes = window['__CONTENT_CACHE']['routing'];
        } catch (error) {
            _routes = {};
        }
        var routeEnterties = Object.entries(_routes ?? {});
        var givenRoutes = routeEnterties.map(([url, alias]) => alias in RouteConfig.pages ? RouteConfig.pages[alias](fixUrl(url)) : RouteConfig.pages.notFoundPage(fixUrl(url)));
        var knownRoutes = [
            RouteConfig.pages['homePage'](''),
            RouteConfig.pages['notFoundPage']('404'),
            RouteConfig.pages['homePage'](lang),
            RouteConfig.pages['productPage']('product/1/1'),
            RouteConfig.pages['productPage'](`${lang}/product/1/1`),
            ...givenRoutes,
            RouteConfig.pages['notFoundPage']('**'),
        ];
        return knownRoutes as Routes;
    }

}
